import { object, pipe } from "valibot";
import { MAX_CHARACTERS_SM } from "../constants";
import { noUrl, requireText } from "../utils/validation/base";

export const customerSchema = object({
  name: pipe(requireText(MAX_CHARACTERS_SM), noUrl()),
});
